import BaseAPI from "../api";

const path: string = "/leave";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
  leave_type_name?: string;
};

export class leaveTypeApi extends BaseAPI {
  static getAllLeaveType(query?: listType): Promise<any> {
    return this.api.get(`${path}/type/list`, {
      params: { ...query },
    });
  }

  static getLeaveTypeById(id: number): Promise<any> {
    return this.api.get(`${path}/type/${id}/detail`);
  }

  static createLeaveType(body: any): Promise<any> {
    return this.api.post(`${path}/type/create`, body);
  }

  static updateLeaveType(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/type/${id}/update`, body);
  }

  static deleteLeaveType(id: number): Promise<any> {
    return this.api.delete(`${path}/type/${id}/delete`);
  }
}
